module.exports = __webpack_public_path__ + "slide6.55c0725542153157806e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/home/slide6.jpg
// module id = ./src/assets/images/private/home/slide6.jpg
// module chunks = main